<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon class="mr-2" v-bind="attrs" v-on="on" @click="$emit('click')">
        {{ icon }}
      </v-icon>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
  export default {
    props: {
      icon: String,
      tooltip: String
    }
  };
</script>
<style></style>
